import Endpoints from 'constants/Endpoints';
import {RestRequestGET} from 'libs/RestRequest';

const get = async () => {
    try {
        return await RestRequestGET(Endpoints.CPV_LIST);
    } catch (error) {
    }
};


export default {
    get
}